export default __webpack_public_path__ + "static/media/journeytray-greentree.66c0f73b.svg";